export enum AuthenticationMode {
    AzureAd = 1,
    DPASS = 2
}